import { StagedLoading } from './components/StagedLoading';

// Progress feedback for the parse wait (mirrors PSCraft's StandaloneEvaluate staged-loader). A spinner +
// staged messages that advance every `intervalMs` and HOLD on the last (so it never claims to finish before the
// parse returns) + an honest "this takes a moment". Pure UI; no data path.
// The parse can run up to the worker's 85s cap on a dense CV, so the parse phase passes a longer intervalMs and
// these 6 stages span ~55s — the last (reassuring) stage is reached near where a real parse lands, then holds for
// the ~30s buffer rather than sitting static from 12s. The faster tagger phase keeps the default 4s.
// Polish B2 — this is now a thin wrapper over the generalized <StagedLoading> (components/StagedLoading.tsx),
// which every other long-wait surface (quality read, guided classify) also uses. testIds kept stable
// (import-parsing / parsing-stage) so existing callers/tests are unaffected.
const PARSE_STAGES = [
  'Reading your CV…',
  'Finding each entry…',
  'Sorting them into sections…',
  'Tidying up the details…',
  'Putting it together…',
  'Almost there — a longer CV can take up to a minute…',
];

export function ParsingIndicator({ stages = PARSE_STAGES, intervalMs = 4000 }: { stages?: string[]; intervalMs?: number }) {
  return (
    <StagedLoading
      stages={stages}
      intervalMs={intervalMs}
      subtext="This takes a moment."
      testId="import-parsing"
      stageTestId="parsing-stage"
    />
  );
}
